import { commsManager } from "appworks/server/comms-manager";
import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { PartnerConnectSpinRequestPayload } from "partner-connect/integration/schema/partner-connect-spin-schema";

export function PartnerConnectRestoreSpinCommand(): Contract<void> {
    const payload = new PartnerConnectSpinRequestPayload();
    payload.creditPerLine = Services.bet.getCreditPerLine();
    payload.creditSize = Services.bet.getCreditSize();
    payload.type = "restore";

    return commsManager.request(payload);
}
